import { render, staticRenderFns } from "./saveDeliverType.vue?vue&type=template&id=277d1c0e&"
import script from "./saveDeliverType.vue?vue&type=script&lang=js&"
export * from "./saveDeliverType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports